function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2238 0H0V415H2238V0Z",
  fill: "#4D00B4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M366.156 390.54C430.299 334.126 483.844 305.919 526.789 305.919C591.207 305.919 624.125 282.097 643.875 247.68C663.625 213.262 893.071 -26.5589 1015.25 21.4687C1096.71 53.487 1135.96 71.7857 1133 76.3647C1214.65 50.7065 1283.31 48.251 1339 68.9984C1394.69 89.7458 1628.35 204.952 2040 414.617H326L366.156 390.54Z",
  fill: "url(#paint0_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M893.8 182H907L893.8 174V182Z",
  fill: "#4D00B4"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M893.8 181.238H903.8L893.8 175.143V181.238Z",
  fill: "#9013FE"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M885 182H877L885 177.048V182Z",
  fill: "#4D00B4"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M885 181.529H878.939L885 177.755V181.529Z",
  fill: "#9013FE"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M899.8 180.095H883V181.619H899.8V180.095Z",
  fill: "#4D00B4"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M720.156 350.156C711.255 289.458 720.231 257.193 747.084 253.359C787.363 247.609 751.826 228.035 774.824 228.035C790.156 228.035 850.831 223.134 956.848 213.332V195H1311.33C1378.06 200.141 1418.6 211.152 1432.93 228.035C1447.27 244.918 1455.7 281.129 1458.22 336.668C1481.32 334.02 1495.85 338.516 1501.81 350.156C1507.77 361.797 1527.46 370.54 1560.88 376.387V387.188H678L720.156 350.156Z",
  fill: "#EAE1F2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1186.05 195.543L1193.54 368H1286.15L1236.7 195.956",
  fill: "#CEC2DA"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.790295,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1316.41 202.949C1379.99 211.072 1415.36 221.176 1422.53 233.264C1433.28 251.395 1440.34 275 1448 338C1450.14 345.777 1456.14 349.666 1466 349.666C1475.86 349.666 1488.01 362.173 1502.43 387.188L1335.74 387L1367 283.607C1367.29 252.257 1353.39 227.688 1325.32 209.901L1316.41 202.949Z",
  fill: "#C7B9D4"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.493676,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1224.43 348.937L1203.93 210.63L1215.05 337.712L1224.43 348.937Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M937.714 386.519L913 387C919.563 324.368 933.701 260.61 955.414 195.728L939.397 365.904L937.714 386.519Z",
  fill: "#DFD1EC"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.295898,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1185.21 196L1194.55 386.567H937L956.288 196",
  fill: "white"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1059.01 386C1156.24 361.031 1205.38 338.956 1206.43 319.773C1208 291 1302.82 257.578 1337.91 263C1373 268.422 1415.04 318 1421.46 347C1425.73 366.333 1417.25 380.666 1396 390L1059.01 386Z",
  fill: "#DFD1EC"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.401251,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1186.01 380.536C1246.06 365.157 1276.41 351.56 1277.06 339.745C1278.03 322.022 1336.59 301.436 1358.27 304.776C1379.94 308.115 1405.91 338.652 1409.87 356.515C1412.51 368.423 1407.27 377.251 1394.14 383L1186.01 380.536Z",
  fill: "white"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1163 191.111H973V195H1163V191.111Z",
  fill: "#4D00B4"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1155.51 187.223H980.792V191.111H1155.51V187.223Z",
  fill: "#4D00B4"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1150.41 182.437H985.886V186.325H1150.41V182.437Z",
  fill: "#4D00B4"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1144.42 124.705H990.382V129.491H1144.42V124.705Z",
  fill: "#4D00B4"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1148.32 115.133H987.984V116.329H1148.32V115.133Z",
  fill: "#4D00B4"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1148.91 111.543H987.385V114.236H1148.91V111.543Z",
  fill: "#4D00B4"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1000.87 182.437L999.812 134.293H992.59L991.096 182.437L992.59 184.373H999.812L1000.87 182.437Z",
  fill: "#4D00B4"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M996.646 135.974C996.646 135.697 996.422 135.474 996.146 135.474C995.87 135.474 995.646 135.697 995.646 135.974V178.347C995.646 178.623 995.87 178.847 996.146 178.847C996.422 178.847 996.646 178.623 996.646 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M994.153 135.477C994.39 135.481 994.579 135.681 994.575 135.924L993.85 178.344C993.846 178.586 993.65 178.779 993.412 178.775C993.175 178.771 992.986 178.571 992.99 178.329L993.715 135.908C993.719 135.666 993.915 135.473 994.153 135.477Z",
  fill: "#9013FE"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M997.999 135.482C998.236 135.477 998.432 135.67 998.436 135.913L999.162 178.333C999.166 178.576 998.977 178.775 998.739 178.78C998.502 178.784 998.306 178.591 998.302 178.348L997.576 135.928C997.572 135.686 997.761 135.486 997.999 135.482Z",
  fill: "#9013FE"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1001.47 180.043H990.382V182.436H1001.47V180.043Z",
  fill: "#9013FE"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1001.47 129.491H990.382V131.884H1001.47V129.491Z",
  fill: "#9013FE"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M999.674 132.184H992.178C991.683 132.184 991.281 132.585 991.281 133.081C991.281 133.577 991.683 133.978 992.178 133.978H999.674C1000.17 133.978 1000.57 133.577 1000.57 133.081C1000.57 132.585 1000.17 132.184 999.674 132.184Z",
  fill: "#4D00B4"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1309.49 182.489L1308.43 134.345H1301.21L1299.71 182.489L1301.21 184.425H1308.43L1309.49 182.489Z",
  fill: "#4D00B4"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1305.26 136.026C1305.26 135.75 1305.04 135.526 1304.76 135.526C1304.49 135.526 1304.26 135.75 1304.26 136.026V178.399C1304.26 178.675 1304.49 178.899 1304.76 178.899C1305.04 178.899 1305.26 178.675 1305.26 178.399V136.026Z",
  fill: "#9013FE"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1302.77 135.529C1303.01 135.534 1303.2 135.733 1303.19 135.976L1302.47 178.396C1302.46 178.639 1302.27 178.832 1302.03 178.827C1301.79 178.823 1301.6 178.623 1301.61 178.381L1302.33 135.961C1302.34 135.718 1302.53 135.525 1302.77 135.529Z",
  fill: "#9013FE"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1306.62 135.534C1306.85 135.53 1307.05 135.723 1307.05 135.965L1307.78 178.385C1307.78 178.628 1307.59 178.828 1307.36 178.832C1307.12 178.836 1306.92 178.643 1306.92 178.401L1306.19 135.98C1306.19 135.738 1306.38 135.538 1306.62 135.534Z",
  fill: "#9013FE"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1310.09 180.096H1299V182.489H1310.09V180.096Z",
  fill: "#9013FE"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1310.09 129.543H1299V131.936H1310.09V129.543Z",
  fill: "#9013FE"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1308.29 132.236H1300.8C1300.3 132.236 1299.9 132.638 1299.9 133.133C1299.9 133.629 1300.3 134.031 1300.8 134.031H1308.29C1308.79 134.031 1309.19 133.629 1309.19 133.133C1309.19 132.638 1308.79 132.236 1308.29 132.236Z",
  fill: "#4D00B4"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1021.55 182.437L1020.49 134.293H1013.27L1011.77 182.437L1013.27 184.373H1020.49L1021.55 182.437Z",
  fill: "#4D00B4"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1017.32 135.974C1017.32 135.697 1017.1 135.474 1016.82 135.474C1016.55 135.474 1016.32 135.697 1016.32 135.974V178.347C1016.32 178.623 1016.55 178.847 1016.82 178.847C1017.1 178.847 1017.32 178.623 1017.32 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1014.83 135.477C1015.07 135.481 1015.26 135.681 1015.25 135.924L1014.53 178.344C1014.52 178.586 1014.33 178.779 1014.09 178.775C1013.85 178.771 1013.66 178.571 1013.67 178.329L1014.39 135.908C1014.4 135.666 1014.59 135.473 1014.83 135.477Z",
  fill: "#9013FE"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1018.68 135.482C1018.91 135.477 1019.11 135.67 1019.11 135.913L1019.84 178.333C1019.84 178.576 1019.65 178.775 1019.42 178.78C1019.18 178.784 1018.98 178.591 1018.98 178.348L1018.25 135.928C1018.25 135.686 1018.44 135.486 1018.68 135.482Z",
  fill: "#9013FE"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1022.15 180.043H1011.06V182.436H1022.15V180.043Z",
  fill: "#9013FE"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1022.15 129.491H1011.06V131.884H1022.15V129.491Z",
  fill: "#9013FE"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1020.35 132.184H1012.86C1012.36 132.184 1011.96 132.585 1011.96 133.081C1011.96 133.577 1012.36 133.978 1012.86 133.978H1020.35C1020.85 133.978 1021.25 133.577 1021.25 133.081C1021.25 132.585 1020.85 132.184 1020.35 132.184Z",
  fill: "#4D00B4"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1041.93 182.437L1040.87 134.293H1033.65L1032.15 182.437L1033.65 184.373H1040.87L1041.93 182.437Z",
  fill: "#4D00B4"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1037.7 135.974C1037.7 135.697 1037.48 135.474 1037.2 135.474C1036.93 135.474 1036.7 135.697 1036.7 135.974V178.347C1036.7 178.623 1036.93 178.847 1037.2 178.847C1037.48 178.847 1037.7 178.623 1037.7 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1035.21 135.477C1035.45 135.481 1035.64 135.681 1035.63 135.924L1034.91 178.344C1034.9 178.586 1034.71 178.779 1034.47 178.775C1034.23 178.771 1034.04 178.571 1034.05 178.329L1034.77 135.908C1034.78 135.666 1034.97 135.473 1035.21 135.477Z",
  fill: "#9013FE"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1039.06 135.482C1039.29 135.477 1039.49 135.67 1039.49 135.913L1040.22 178.333C1040.22 178.576 1040.03 178.775 1039.8 178.78C1039.56 178.784 1039.36 178.591 1039.36 178.348L1038.63 135.928C1038.63 135.686 1038.82 135.486 1039.06 135.482Z",
  fill: "#9013FE"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1042.53 180.043H1031.44V182.436H1042.53V180.043Z",
  fill: "#9013FE"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1042.53 129.491H1031.44V131.884H1042.53V129.491Z",
  fill: "#9013FE"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1040.73 132.184H1033.23C1032.74 132.184 1032.34 132.585 1032.34 133.081C1032.34 133.577 1032.74 133.978 1033.23 133.978H1040.73C1041.23 133.978 1041.63 133.577 1041.63 133.081C1041.63 132.585 1041.23 132.184 1040.73 132.184Z",
  fill: "#4D00B4"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1062.31 182.437L1061.25 134.293H1054.02L1052.53 182.437L1054.02 184.373H1061.25L1062.31 182.437Z",
  fill: "#4D00B4"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1058.08 135.974C1058.08 135.697 1057.86 135.474 1057.58 135.474C1057.3 135.474 1057.08 135.697 1057.08 135.974V178.347C1057.08 178.623 1057.3 178.847 1057.58 178.847C1057.86 178.847 1058.08 178.623 1058.08 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1055.59 135.477C1055.83 135.481 1056.01 135.681 1056.01 135.924L1055.29 178.344C1055.28 178.586 1055.09 178.779 1054.85 178.775C1054.61 178.771 1054.42 178.571 1054.43 178.329L1055.15 135.908C1055.15 135.666 1055.35 135.473 1055.59 135.477Z",
  fill: "#9013FE"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1059.43 135.482C1059.67 135.477 1059.87 135.67 1059.87 135.913L1060.6 178.333C1060.6 178.576 1060.41 178.775 1060.17 178.78C1059.94 178.784 1059.74 178.591 1059.74 178.348L1059.01 135.928C1059.01 135.686 1059.2 135.486 1059.43 135.482Z",
  fill: "#9013FE"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1062.91 180.043H1051.82V182.436H1062.91V180.043Z",
  fill: "#9013FE"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1062.91 129.491H1051.82V131.884H1062.91V129.491Z",
  fill: "#9013FE"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1061.11 132.184H1053.61C1053.12 132.184 1052.72 132.585 1052.72 133.081C1052.72 133.577 1053.12 133.978 1053.61 133.978H1061.11C1061.6 133.978 1062.01 133.577 1062.01 133.081C1062.01 132.585 1061.6 132.184 1061.11 132.184Z",
  fill: "#4D00B4"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1082.68 182.437L1081.63 134.293H1074.4L1072.91 182.437L1074.4 184.373H1081.63L1082.68 182.437Z",
  fill: "#4D00B4"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1078.46 135.974C1078.46 135.697 1078.24 135.474 1077.96 135.474C1077.68 135.474 1077.46 135.697 1077.46 135.974V178.347C1077.46 178.623 1077.68 178.847 1077.96 178.847C1078.24 178.847 1078.46 178.623 1078.46 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1075.97 135.477C1076.2 135.481 1076.39 135.681 1076.39 135.924L1075.66 178.344C1075.66 178.586 1075.46 178.779 1075.23 178.775C1074.99 178.771 1074.8 178.571 1074.8 178.329L1075.53 135.908C1075.53 135.666 1075.73 135.473 1075.97 135.477Z",
  fill: "#9013FE"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1079.81 135.482C1080.05 135.477 1080.25 135.67 1080.25 135.913L1080.98 178.333C1080.98 178.576 1080.79 178.775 1080.55 178.78C1080.32 178.784 1080.12 178.591 1080.12 178.348L1079.39 135.928C1079.39 135.686 1079.58 135.486 1079.81 135.482Z",
  fill: "#9013FE"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1083.28 180.043H1072.2V182.436H1083.28V180.043Z",
  fill: "#9013FE"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1083.28 129.491H1072.2V131.884H1083.28V129.491Z",
  fill: "#9013FE"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1081.49 132.184H1073.99C1073.5 132.184 1073.09 132.585 1073.09 133.081C1073.09 133.577 1073.5 133.978 1073.99 133.978H1081.49C1081.98 133.978 1082.38 133.577 1082.38 133.081C1082.38 132.585 1081.98 132.184 1081.49 132.184Z",
  fill: "#4D00B4"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1103.06 182.437L1102 134.293H1094.78L1093.29 182.437L1094.78 184.373H1102L1103.06 182.437Z",
  fill: "#4D00B4"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1098.84 135.974C1098.84 135.697 1098.61 135.474 1098.34 135.474C1098.06 135.474 1097.84 135.697 1097.84 135.974V178.347C1097.84 178.623 1098.06 178.847 1098.34 178.847C1098.61 178.847 1098.84 178.623 1098.84 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1096.35 135.477C1096.58 135.481 1096.77 135.681 1096.77 135.924L1096.04 178.344C1096.04 178.586 1095.84 178.779 1095.6 178.775C1095.37 178.771 1095.18 178.571 1095.18 178.329L1095.91 135.908C1095.91 135.666 1096.11 135.473 1096.35 135.477Z",
  fill: "#9013FE"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1100.19 135.482C1100.43 135.477 1100.62 135.67 1100.63 135.913L1101.35 178.333C1101.36 178.576 1101.17 178.775 1100.93 178.78C1100.69 178.784 1100.5 178.591 1100.49 178.348L1099.77 135.928C1099.76 135.686 1099.95 135.486 1100.19 135.482Z",
  fill: "#9013FE"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1103.66 180.043H1092.57V182.436H1103.66V180.043Z",
  fill: "#9013FE"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1103.66 129.491H1092.57V131.884H1103.66V129.491Z",
  fill: "#9013FE"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1101.87 132.184H1094.37C1093.87 132.184 1093.47 132.585 1093.47 133.081C1093.47 133.577 1093.87 133.978 1094.37 133.978H1101.87C1102.36 133.978 1102.76 133.577 1102.76 133.081C1102.76 132.585 1102.36 132.184 1101.87 132.184Z",
  fill: "#4D00B4"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1123.44 182.437L1122.38 134.293H1115.16L1113.67 182.437L1115.16 184.373H1122.38L1123.44 182.437Z",
  fill: "#4D00B4"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1119.22 135.974C1119.22 135.697 1118.99 135.474 1118.72 135.474C1118.44 135.474 1118.22 135.697 1118.22 135.974V178.347C1118.22 178.623 1118.44 178.847 1118.72 178.847C1118.99 178.847 1119.22 178.623 1119.22 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1116.72 135.477C1116.96 135.481 1117.15 135.681 1117.15 135.924L1116.42 178.344C1116.42 178.586 1116.22 178.779 1115.98 178.775C1115.75 178.771 1115.56 178.571 1115.56 178.329L1116.29 135.908C1116.29 135.666 1116.49 135.473 1116.72 135.477Z",
  fill: "#9013FE"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1120.57 135.482C1120.81 135.477 1121 135.67 1121.01 135.913L1121.73 178.333C1121.74 178.576 1121.55 178.775 1121.31 178.78C1121.07 178.784 1120.88 178.591 1120.87 178.348L1120.15 135.928C1120.14 135.686 1120.33 135.486 1120.57 135.482Z",
  fill: "#9013FE"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1124.04 180.043H1112.95V182.436H1124.04V180.043Z",
  fill: "#9013FE"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1124.04 129.491H1112.95V131.884H1124.04V129.491Z",
  fill: "#9013FE"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1122.24 132.184H1114.75C1114.25 132.184 1113.85 132.585 1113.85 133.081C1113.85 133.577 1114.25 133.978 1114.75 133.978H1122.24C1122.74 133.978 1123.14 133.577 1123.14 133.081C1123.14 132.585 1122.74 132.184 1122.24 132.184Z",
  fill: "#4D00B4"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1143.82 182.437L1142.76 134.293H1135.54L1134.05 182.437L1135.54 184.373H1142.76L1143.82 182.437Z",
  fill: "#4D00B4"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1139.6 135.974C1139.6 135.697 1139.37 135.474 1139.1 135.474C1138.82 135.474 1138.6 135.697 1138.6 135.974V178.347C1138.6 178.623 1138.82 178.847 1139.1 178.847C1139.37 178.847 1139.6 178.623 1139.6 178.347V135.974Z",
  fill: "#9013FE"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1137.1 135.477C1137.34 135.481 1137.53 135.681 1137.52 135.924L1136.8 178.344C1136.8 178.586 1136.6 178.779 1136.36 178.775C1136.12 178.771 1135.94 178.571 1135.94 178.329L1136.66 135.908C1136.67 135.666 1136.86 135.473 1137.1 135.477Z",
  fill: "#9013FE"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1140.95 135.482C1141.19 135.477 1141.38 135.67 1141.39 135.913L1142.11 178.333C1142.12 178.576 1141.93 178.775 1141.69 178.78C1141.45 178.784 1141.26 178.591 1141.25 178.348L1140.53 135.928C1140.52 135.686 1140.71 135.486 1140.95 135.482Z",
  fill: "#9013FE"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1144.42 180.043H1133.33V182.436H1144.42V180.043Z",
  fill: "#9013FE"
});

var _ref84 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1144.42 129.491H1133.33V131.884H1144.42V129.491Z",
  fill: "#9013FE"
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1142.62 132.184H1135.13C1134.63 132.184 1134.23 132.585 1134.23 133.081C1134.23 133.577 1134.63 133.978 1135.13 133.978H1142.62C1143.12 133.978 1143.52 133.577 1143.52 133.081C1143.52 132.585 1143.12 132.184 1142.62 132.184Z",
  fill: "#4D00B4"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M993.678 117.227H990.981V124.107H993.678V117.227Z",
  fill: "#4D00B4"
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1144.42 117.227H1141.72V124.107H1144.42V117.227Z",
  fill: "#4D00B4"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M996.076 117.227H994.877V124.107H996.076V117.227Z",
  fill: "#4D00B4"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1004.17 117.227H997.274V124.107H1004.17V117.227Z",
  fill: "#4D00B4"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1006.56 117.227H1005.37V124.107H1006.56V117.227Z",
  fill: "#4D00B4"
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1014.66 117.227H1007.76V124.107H1014.66V117.227Z",
  fill: "#4D00B4"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1017.05 117.227H1015.85V124.107H1017.05V117.227Z",
  fill: "#4D00B4"
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1025.15 117.227H1018.25V124.107H1025.15V117.227Z",
  fill: "#4D00B4"
});

var _ref94 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1027.54 117.227H1026.34V124.107H1027.54V117.227Z",
  fill: "#4D00B4"
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1035.63 117.227H1028.74V124.107H1035.63V117.227Z",
  fill: "#4D00B4"
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1038.03 117.227H1036.83V124.107H1038.03V117.227Z",
  fill: "#4D00B4"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1046.12 117.227H1039.23V124.107H1046.12V117.227Z",
  fill: "#4D00B4"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1048.52 117.227H1047.32V124.107H1048.52V117.227Z",
  fill: "#4D00B4"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1056.61 117.227H1049.72V124.107H1056.61V117.227Z",
  fill: "#4D00B4"
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1059.01 117.227H1057.81V124.107H1059.01V117.227Z",
  fill: "#4D00B4"
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1067.1 117.227H1060.21V124.107H1067.1V117.227Z",
  fill: "#4D00B4"
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1069.5 117.227H1068.3V124.107H1069.5V117.227Z",
  fill: "#4D00B4"
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1077.59 117.227H1070.7V124.107H1077.59V117.227Z",
  fill: "#4D00B4"
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1079.99 117.227H1078.79V124.107H1079.99V117.227Z",
  fill: "#4D00B4"
});

var _ref105 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1088.08 117.227H1081.19V124.107H1088.08V117.227Z",
  fill: "#4D00B4"
});

var _ref106 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1090.48 117.227H1089.28V124.107H1090.48V117.227Z",
  fill: "#4D00B4"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1098.57 117.227H1091.68V124.107H1098.57V117.227Z",
  fill: "#4D00B4"
});

var _ref108 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1100.97 117.227H1099.77V124.107H1100.97V117.227Z",
  fill: "#4D00B4"
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1109.06 117.227H1102.16V124.107H1109.06V117.227Z",
  fill: "#4D00B4"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1111.45 117.227H1110.26V124.107H1111.45V117.227Z",
  fill: "#4D00B4"
});

var _ref111 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1119.55 117.227H1112.65V124.107H1119.55V117.227Z",
  fill: "#4D00B4"
});

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1121.94 117.227H1120.74V124.107H1121.94V117.227Z",
  fill: "#4D00B4"
});

var _ref113 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1130.03 117.227H1123.14V124.107H1130.03V117.227Z",
  fill: "#4D00B4"
});

var _ref114 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1132.43 117.227H1131.23V124.107H1132.43V117.227Z",
  fill: "#4D00B4"
});

var _ref115 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1140.52 117.227H1133.63V124.107H1140.52V117.227Z",
  fill: "#4D00B4"
});

var _ref116 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1066.98 59.4097L991.619 105.857H1142.29L1066.98 59.4097Z",
  fill: "#9013FE",
  stroke: "#4D00B4",
  strokeWidth: 2.4
});

var _ref117 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1066.97 64.7949L1007.79 101.37H1126.11L1066.97 64.7949Z",
  fill: "#9013FE",
  stroke: "#4D00B4",
  strokeWidth: 2.4
});

var _ref118 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1066.97 69.6658L1112.05 97.4845H1021.85L1066.97 69.6658Z",
  fill: "#4D00B4"
});

var _ref119 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1282 107H1315L1282 86V107Z",
  fill: "#4D00B4"
});

var _ref120 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1282 105H1307L1282 89V105Z",
  fill: "#9013FE"
});

var _ref121 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1260 107H1240L1260 94V107Z",
  fill: "#4D00B4"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1260 105.762H1244.85L1260 95.8569V105.762Z",
  fill: "#9013FE"
});

var _ref123 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1297 102H1255V106H1297V102Z",
  fill: "#4D00B4"
});

var _ref124 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1310 105H1156V107H1310V105Z",
  fill: "#4D00B4"
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1164 99H1156V107H1164V99Z",
  fill: "#4D00B4"
});

var _ref126 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1181 99H1173V107H1181V99Z",
  fill: "#4D00B4"
});

var _ref127 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1198 99H1190V107H1198V99Z",
  fill: "#4D00B4"
});

var _ref128 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1215 99H1207V107H1215V99Z",
  fill: "#4D00B4"
});

var _ref129 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1232 99H1224V107H1232V99Z",
  fill: "#4D00B4"
});

var _ref130 =
/*#__PURE__*/
React.createElement("path", {
  d: "M898 181H844V182H898V181Z",
  fill: "#4D00B4"
});

var _ref131 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.238514,
  d: "M905 193H813V195H905V193Z",
  fill: "#9013FE"
});

var _ref132 =
/*#__PURE__*/
React.createElement("path", {
  d: "M847 179H844V182H847V179Z",
  fill: "#4D00B4"
});

var _ref133 =
/*#__PURE__*/
React.createElement("path", {
  d: "M853 179H850V182H853V179Z",
  fill: "#4D00B4"
});

var _ref134 =
/*#__PURE__*/
React.createElement("path", {
  d: "M859 179H856V182H859V179Z",
  fill: "#4D00B4"
});

var _ref135 =
/*#__PURE__*/
React.createElement("path", {
  d: "M865 179H862V182H865V179Z",
  fill: "#4D00B4"
});

var _ref136 =
/*#__PURE__*/
React.createElement("path", {
  d: "M871 179H868V182H871V179Z",
  fill: "#4D00B4"
});

var _ref137 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.802781
}, React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1329 191.111H1139V195H1329V191.111Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1321.51 187.223H1146.79V191.111H1321.51V187.223Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1316.41 182.437H1151.89V186.325H1316.41V182.437Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1310.42 124.705H1156.38V129.491H1310.42V124.705Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1314.32 115.133H1153.98V116.329H1314.32V115.133Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1314.91 111.543H1153.38V114.236H1314.91V111.543Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1166.87 182.437L1165.81 134.293H1158.59L1157.1 182.437L1158.59 184.373H1165.81L1166.87 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1162.65 135.974C1162.65 135.697 1162.42 135.474 1162.15 135.474C1161.87 135.474 1161.65 135.697 1161.65 135.974V178.347C1161.65 178.623 1161.87 178.847 1162.15 178.847C1162.42 178.847 1162.65 178.623 1162.65 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1160.15 135.477C1160.39 135.481 1160.58 135.681 1160.58 135.924L1159.85 178.344C1159.85 178.586 1159.65 178.779 1159.41 178.775C1159.17 178.771 1158.99 178.571 1158.99 178.329L1159.72 135.908C1159.72 135.666 1159.92 135.473 1160.15 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1164 135.482C1164.24 135.477 1164.43 135.67 1164.44 135.913L1165.16 178.333C1165.17 178.576 1164.98 178.775 1164.74 178.78C1164.5 178.784 1164.31 178.591 1164.3 178.348L1163.58 135.928C1163.57 135.686 1163.76 135.486 1164 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1167.47 180.043H1156.38V182.436H1167.47V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1167.47 129.491H1156.38V131.884H1167.47V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1165.67 132.184H1158.18C1157.68 132.184 1157.28 132.585 1157.28 133.081C1157.28 133.577 1157.68 133.978 1158.18 133.978H1165.67C1166.17 133.978 1166.57 133.577 1166.57 133.081C1166.57 132.585 1166.17 132.184 1165.67 132.184Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1187.55 182.437L1186.49 134.293H1179.27L1177.77 182.437L1179.27 184.373H1186.49L1187.55 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1183.32 135.974C1183.32 135.697 1183.1 135.474 1182.82 135.474C1182.55 135.474 1182.32 135.697 1182.32 135.974V178.347C1182.32 178.623 1182.55 178.847 1182.82 178.847C1183.1 178.847 1183.32 178.623 1183.32 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1180.83 135.477C1181.07 135.481 1181.26 135.681 1181.25 135.924L1180.53 178.344C1180.52 178.586 1180.33 178.779 1180.09 178.775C1179.85 178.771 1179.66 178.571 1179.67 178.329L1180.39 135.908C1180.4 135.666 1180.59 135.473 1180.83 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1184.68 135.482C1184.91 135.477 1185.11 135.67 1185.11 135.913L1185.84 178.333C1185.84 178.576 1185.65 178.775 1185.42 178.78C1185.18 178.784 1184.98 178.591 1184.98 178.348L1184.25 135.928C1184.25 135.686 1184.44 135.486 1184.68 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1188.15 180.043H1177.06V182.436H1188.15V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1188.15 129.491H1177.06V131.884H1188.15V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1186.35 132.184H1178.86C1178.36 132.184 1177.96 132.585 1177.96 133.081C1177.96 133.577 1178.36 133.978 1178.86 133.978H1186.35C1186.85 133.978 1187.25 133.577 1187.25 133.081C1187.25 132.585 1186.85 132.184 1186.35 132.184Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1207.93 182.437L1206.87 134.293H1199.65L1198.15 182.437L1199.65 184.373H1206.87L1207.93 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1203.7 135.974C1203.7 135.697 1203.48 135.474 1203.2 135.474C1202.93 135.474 1202.7 135.697 1202.7 135.974V178.347C1202.7 178.623 1202.93 178.847 1203.2 178.847C1203.48 178.847 1203.7 178.623 1203.7 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1201.21 135.477C1201.45 135.481 1201.64 135.681 1201.63 135.924L1200.91 178.344C1200.9 178.586 1200.71 178.779 1200.47 178.775C1200.23 178.771 1200.04 178.571 1200.05 178.329L1200.77 135.908C1200.78 135.666 1200.97 135.473 1201.21 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1205.06 135.482C1205.29 135.477 1205.49 135.67 1205.49 135.913L1206.22 178.333C1206.22 178.576 1206.03 178.775 1205.8 178.78C1205.56 178.784 1205.36 178.591 1205.36 178.348L1204.63 135.928C1204.63 135.686 1204.82 135.486 1205.06 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1208.53 180.043H1197.44V182.436H1208.53V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1208.53 129.491H1197.44V131.884H1208.53V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1206.73 132.184H1199.23C1198.74 132.184 1198.34 132.585 1198.34 133.081C1198.34 133.577 1198.74 133.978 1199.23 133.978H1206.73C1207.23 133.978 1207.63 133.577 1207.63 133.081C1207.63 132.585 1207.23 132.184 1206.73 132.184Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1228.31 182.437L1227.25 134.293H1220.02L1218.53 182.437L1220.02 184.373H1227.25L1228.31 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1224.08 135.974C1224.08 135.697 1223.86 135.474 1223.58 135.474C1223.3 135.474 1223.08 135.697 1223.08 135.974V178.347C1223.08 178.623 1223.3 178.847 1223.58 178.847C1223.86 178.847 1224.08 178.623 1224.08 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1221.59 135.477C1221.83 135.481 1222.01 135.681 1222.01 135.924L1221.29 178.344C1221.28 178.586 1221.09 178.779 1220.85 178.775C1220.61 178.771 1220.42 178.571 1220.43 178.329L1221.15 135.908C1221.15 135.666 1221.35 135.473 1221.59 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1225.43 135.482C1225.67 135.477 1225.87 135.67 1225.87 135.913L1226.6 178.333C1226.6 178.576 1226.41 178.775 1226.17 178.78C1225.94 178.784 1225.74 178.591 1225.74 178.348L1225.01 135.928C1225.01 135.686 1225.2 135.486 1225.43 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1228.91 180.043H1217.82V182.436H1228.91V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1228.91 129.491H1217.82V131.884H1228.91V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1227.11 132.184H1219.61C1219.12 132.184 1218.72 132.585 1218.72 133.081C1218.72 133.577 1219.12 133.978 1219.61 133.978H1227.11C1227.6 133.978 1228.01 133.577 1228.01 133.081C1228.01 132.585 1227.6 132.184 1227.11 132.184Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1248.68 182.437L1247.63 134.293H1240.4L1238.91 182.437L1240.4 184.373H1247.63L1248.68 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1244.46 135.974C1244.46 135.697 1244.24 135.474 1243.96 135.474C1243.68 135.474 1243.46 135.697 1243.46 135.974V178.347C1243.46 178.623 1243.68 178.847 1243.96 178.847C1244.24 178.847 1244.46 178.623 1244.46 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1241.97 135.477C1242.2 135.481 1242.39 135.681 1242.39 135.924L1241.66 178.344C1241.66 178.586 1241.46 178.779 1241.23 178.775C1240.99 178.771 1240.8 178.571 1240.8 178.329L1241.53 135.908C1241.53 135.666 1241.73 135.473 1241.97 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1245.81 135.482C1246.05 135.477 1246.25 135.67 1246.25 135.913L1246.98 178.333C1246.98 178.576 1246.79 178.775 1246.55 178.78C1246.32 178.784 1246.12 178.591 1246.12 178.348L1245.39 135.928C1245.39 135.686 1245.58 135.486 1245.81 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1249.28 180.043H1238.2V182.436H1249.28V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1249.28 129.491H1238.2V131.884H1249.28V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1247.49 132.184H1239.99C1239.5 132.184 1239.09 132.585 1239.09 133.081C1239.09 133.577 1239.5 133.978 1239.99 133.978H1247.49C1247.98 133.978 1248.38 133.577 1248.38 133.081C1248.38 132.585 1247.98 132.184 1247.49 132.184Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1269.06 182.437L1268 134.293H1260.78L1259.29 182.437L1260.78 184.373H1268L1269.06 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1264.84 135.974C1264.84 135.697 1264.61 135.474 1264.34 135.474C1264.06 135.474 1263.84 135.697 1263.84 135.974V178.347C1263.84 178.623 1264.06 178.847 1264.34 178.847C1264.61 178.847 1264.84 178.623 1264.84 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1262.35 135.477C1262.58 135.481 1262.77 135.681 1262.77 135.924L1262.04 178.344C1262.04 178.586 1261.84 178.779 1261.6 178.775C1261.37 178.771 1261.18 178.571 1261.18 178.329L1261.91 135.908C1261.91 135.666 1262.11 135.473 1262.35 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1266.19 135.482C1266.43 135.477 1266.62 135.67 1266.63 135.913L1267.35 178.333C1267.36 178.576 1267.17 178.775 1266.93 178.78C1266.69 178.784 1266.5 178.591 1266.49 178.348L1265.77 135.928C1265.76 135.686 1265.95 135.486 1266.19 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1269.66 180.043H1258.57V182.436H1269.66V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1269.66 129.491H1258.57V131.884H1269.66V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1267.87 132.184H1260.37C1259.87 132.184 1259.47 132.585 1259.47 133.081C1259.47 133.577 1259.87 133.978 1260.37 133.978H1267.87C1268.36 133.978 1268.76 133.577 1268.76 133.081C1268.76 132.585 1268.36 132.184 1267.87 132.184Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1289.44 182.437L1288.38 134.293H1281.16L1279.67 182.437L1281.16 184.373H1288.38L1289.44 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1285.22 135.974C1285.22 135.697 1284.99 135.474 1284.72 135.474C1284.44 135.474 1284.22 135.697 1284.22 135.974V178.347C1284.22 178.623 1284.44 178.847 1284.72 178.847C1284.99 178.847 1285.22 178.623 1285.22 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1282.72 135.477C1282.96 135.481 1283.15 135.681 1283.15 135.924L1282.42 178.344C1282.42 178.586 1282.22 178.779 1281.98 178.775C1281.75 178.771 1281.56 178.571 1281.56 178.329L1282.29 135.908C1282.29 135.666 1282.49 135.473 1282.72 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1286.57 135.482C1286.81 135.477 1287 135.67 1287.01 135.913L1287.73 178.333C1287.74 178.576 1287.55 178.775 1287.31 178.78C1287.07 178.784 1286.88 178.591 1286.87 178.348L1286.15 135.928C1286.14 135.686 1286.33 135.486 1286.57 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1290.04 180.043H1278.95V182.436H1290.04V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1290.04 129.491H1278.95V131.884H1290.04V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1288.24 132.184H1280.75C1280.25 132.184 1279.85 132.585 1279.85 133.081C1279.85 133.577 1280.25 133.978 1280.75 133.978H1288.24C1288.74 133.978 1289.14 133.577 1289.14 133.081C1289.14 132.585 1288.74 132.184 1288.24 132.184Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1309.82 182.437L1308.76 134.293H1301.54L1300.05 182.437L1301.54 184.373H1308.76L1309.82 182.437Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M1305.6 135.974C1305.6 135.697 1305.37 135.474 1305.1 135.474C1304.82 135.474 1304.6 135.697 1304.6 135.974V178.347C1304.6 178.623 1304.82 178.847 1305.1 178.847C1305.37 178.847 1305.6 178.623 1305.6 178.347V135.974Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1303.1 135.477C1303.34 135.481 1303.53 135.681 1303.52 135.924L1302.8 178.344C1302.8 178.586 1302.6 178.779 1302.36 178.775C1302.12 178.771 1301.94 178.571 1301.94 178.329L1302.66 135.908C1302.67 135.666 1302.86 135.473 1303.1 135.477Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1306.95 135.482C1307.19 135.477 1307.38 135.67 1307.39 135.913L1308.11 178.333C1308.12 178.576 1307.93 178.775 1307.69 178.78C1307.45 178.784 1307.26 178.591 1307.25 178.348L1306.53 135.928C1306.52 135.686 1306.71 135.486 1306.95 135.482Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1310.42 180.043H1299.33V182.436H1310.42V180.043Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1310.42 129.491H1299.33V131.884H1310.42V129.491Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1308.62 132.184H1301.13C1300.63 132.184 1300.23 132.585 1300.23 133.081C1300.23 133.577 1300.63 133.978 1301.13 133.978H1308.62C1309.12 133.978 1309.52 133.577 1309.52 133.081C1309.52 132.585 1309.12 132.184 1308.62 132.184Z",
  fill: "#4D00B4"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M1159.68 117.227H1156.98V124.107H1159.68V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1310.42 117.227H1307.72V124.107H1310.42V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1162.08 117.227H1160.88V124.107H1162.08V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1170.17 117.227H1163.27V124.107H1170.17V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1172.56 117.227H1171.37V124.107H1172.56V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1180.66 117.227H1173.76V124.107H1180.66V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1183.05 117.227H1181.85V124.107H1183.05V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1191.15 117.227H1184.25V124.107H1191.15V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1193.54 117.227H1192.34V124.107H1193.54V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1201.63 117.227H1194.74V124.107H1201.63V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1204.03 117.227H1202.83V124.107H1204.03V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1212.12 117.227H1205.23V124.107H1212.12V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1214.52 117.227H1213.32V124.107H1214.52V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1222.61 117.227H1215.72V124.107H1222.61V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1225.01 117.227H1223.81V124.107H1225.01V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1233.1 117.227H1226.21V124.107H1233.1V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1235.5 117.227H1234.3V124.107H1235.5V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1243.59 117.227H1236.7V124.107H1243.59V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1245.99 117.227H1244.79V124.107H1245.99V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1254.08 117.227H1247.19V124.107H1254.08V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1256.48 117.227H1255.28V124.107H1256.48V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1264.57 117.227H1257.68V124.107H1264.57V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1266.97 117.227H1265.77V124.107H1266.97V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1275.06 117.227H1268.16V124.107H1275.06V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1277.45 117.227H1276.26V124.107H1277.45V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1285.55 117.227H1278.65V124.107H1285.55V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1287.94 117.227H1286.74V124.107H1287.94V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1296.03 117.227H1289.14V124.107H1296.03V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1298.43 117.227H1297.23V124.107H1298.43V117.227Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M1306.52 117.227H1299.63V124.107H1306.52V117.227Z",
  fill: "#4D00B4"
})));

var _ref138 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.802781
}, React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M913 215.426H837V217H913V215.426Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M910.003 213.852H840.117V215.426H910.003V213.852Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M907.965 211.915H842.155V213.489H907.965V211.915Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M905.568 188.547H843.953V190.484H905.568V188.547Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M907.126 184.673H842.994V185.673H907.126V184.673Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M907.366 183.22H842.754V184.309H907.366V183.22Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M848.148 211.914L847.725 192.428H844.836L844.238 211.914L844.836 212.698H847.725L848.148 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M846.758 192.906H846.358C846.193 192.906 846.058 193.04 846.058 193.206V210.162C846.058 210.327 846.193 210.462 846.358 210.462H846.758C846.924 210.462 847.058 210.327 847.058 210.162V193.206C847.058 193.04 846.924 192.906 846.758 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M845.461 192.907C845.556 192.909 845.632 192.99 845.63 193.088L845.34 210.258C845.338 210.356 845.26 210.434 845.165 210.433C845.07 210.431 844.994 210.35 844.996 210.252L845.286 193.082C845.288 192.984 845.366 192.906 845.461 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M846.999 192.909C847.094 192.907 847.173 192.985 847.174 193.083L847.465 210.253C847.466 210.352 847.391 210.432 847.296 210.434C847.201 210.436 847.122 210.358 847.121 210.26L846.831 193.089C846.829 192.991 846.905 192.91 846.999 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M848.388 210.946H843.953V211.946H848.388V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M848.388 190.484H843.953V191.484H848.388V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M847.668 191.574H844.672C844.473 191.574 844.312 191.735 844.312 191.934V192.214C844.312 192.413 844.473 192.574 844.672 192.574H847.668C847.867 192.574 848.028 192.413 848.028 192.214V191.934C848.028 191.735 847.867 191.574 847.668 191.574Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M856.42 211.914L855.996 192.428H853.107L852.51 211.914L853.107 212.698H855.996L856.42 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M855.03 192.906H854.63C854.464 192.906 854.33 193.04 854.33 193.206V210.162C854.33 210.327 854.464 210.462 854.63 210.462H855.03C855.195 210.462 855.33 210.327 855.33 210.162V193.206C855.33 193.04 855.195 192.906 855.03 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M853.732 192.907C853.827 192.909 853.903 192.99 853.901 193.088L853.611 210.258C853.61 210.356 853.531 210.434 853.436 210.433C853.341 210.431 853.266 210.35 853.267 210.252L853.557 193.082C853.559 192.984 853.637 192.906 853.732 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M855.271 192.909C855.366 192.907 855.444 192.985 855.446 193.083L855.736 210.253C855.738 210.352 855.662 210.432 855.567 210.434C855.472 210.436 855.394 210.358 855.392 210.26L855.102 193.089C855.1 192.991 855.176 192.91 855.271 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M856.659 210.946H852.224V211.946H856.659V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M856.659 190.484H852.224V191.484H856.659V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M855.94 191.574H852.944C852.745 191.574 852.584 191.735 852.584 191.934V192.214C852.584 192.413 852.745 192.574 852.944 192.574H855.94C856.138 192.574 856.3 192.413 856.3 192.214V191.934C856.3 191.735 856.138 191.574 855.94 191.574Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M864.571 211.914L864.147 192.428H861.259L860.661 211.914L861.259 212.698H864.147L864.571 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M863.181 192.906H862.781C862.615 192.906 862.481 193.04 862.481 193.206V210.162C862.481 210.327 862.615 210.462 862.781 210.462H863.181C863.347 210.462 863.481 210.327 863.481 210.162V193.206C863.481 193.04 863.347 192.906 863.181 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M861.884 192.907C861.979 192.909 862.054 192.99 862.053 193.088L861.763 210.258C861.761 210.356 861.683 210.434 861.588 210.433C861.493 210.431 861.417 210.35 861.419 210.252L861.709 193.082C861.71 192.984 861.789 192.906 861.884 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M863.422 192.909C863.517 192.907 863.596 192.985 863.597 193.083L863.887 210.253C863.889 210.352 863.813 210.432 863.718 210.434C863.623 210.436 863.545 210.358 863.543 210.26L863.253 193.089C863.252 192.991 863.327 192.91 863.422 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M864.811 210.946H860.375V211.946H864.811V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M864.811 190.484H860.375V191.484H864.811V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M864.091 191.574H861.095C860.896 191.574 860.735 191.735 860.735 191.934V192.214C860.735 192.413 860.896 192.574 861.095 192.574H864.091C864.29 192.574 864.451 192.413 864.451 192.214V191.934C864.451 191.735 864.29 191.574 864.091 191.574Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M872.722 211.914L872.299 192.428H869.41L868.812 211.914L869.41 212.698H872.299L872.722 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M871.332 192.906H870.932C870.767 192.906 870.632 193.04 870.632 193.206V210.162C870.632 210.327 870.767 210.462 870.932 210.462H871.332C871.498 210.462 871.632 210.327 871.632 210.162V193.206C871.632 193.04 871.498 192.906 871.332 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M870.035 192.907C870.13 192.909 870.206 192.99 870.204 193.088L869.914 210.258C869.912 210.356 869.834 210.434 869.739 210.433C869.644 210.431 869.568 210.35 869.57 210.252L869.86 193.082C869.862 192.984 869.94 192.906 870.035 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M871.574 192.909C871.669 192.907 871.747 192.985 871.749 193.083L872.039 210.253C872.04 210.352 871.965 210.432 871.87 210.434C871.775 210.436 871.697 210.358 871.695 210.26L871.405 193.089C871.403 192.991 871.479 192.91 871.574 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M872.962 210.946H868.527V211.946H872.962V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M872.962 190.484H868.527V191.484H872.962V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M872.243 191.574H869.246C869.048 191.574 868.886 191.735 868.886 191.934V192.214C868.886 192.413 869.048 192.574 869.246 192.574H872.243C872.441 192.574 872.603 192.413 872.603 192.214V191.934C872.603 191.735 872.441 191.574 872.243 191.574Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M880.874 211.914L880.45 192.428H877.561L876.964 211.914L877.561 212.698H880.45L880.874 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M879.484 192.906H879.084C878.918 192.906 878.784 193.04 878.784 193.206V210.162C878.784 210.327 878.918 210.462 879.084 210.462H879.484C879.65 210.462 879.784 210.327 879.784 210.162V193.206C879.784 193.04 879.65 192.906 879.484 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M878.187 192.907C878.282 192.909 878.357 192.99 878.356 193.088L878.065 210.258C878.064 210.356 877.985 210.434 877.89 210.433C877.795 210.431 877.72 210.35 877.721 210.252L878.012 193.082C878.013 192.984 878.092 192.906 878.187 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M879.725 192.909C879.82 192.907 879.898 192.985 879.9 193.083L880.19 210.253C880.192 210.352 880.116 210.432 880.021 210.434C879.926 210.436 879.848 210.358 879.846 210.26L879.556 193.089C879.554 192.991 879.63 192.91 879.725 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M881.114 210.946H876.678V211.946H881.114V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M881.114 190.484H876.678V191.484H881.114V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M880.394 191.574H877.398C877.199 191.574 877.038 191.735 877.038 191.934V192.214C877.038 192.413 877.199 192.574 877.398 192.574H880.394C880.593 192.574 880.754 192.413 880.754 192.214V191.934C880.754 191.735 880.593 191.574 880.394 191.574Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M889.025 211.914L888.602 192.428H885.713L885.115 211.914L885.713 212.698H888.602L889.025 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M887.635 192.906H887.235C887.07 192.906 886.935 193.04 886.935 193.206V210.162C886.935 210.327 887.07 210.462 887.235 210.462H887.635C887.801 210.462 887.935 210.327 887.935 210.162V193.206C887.935 193.04 887.801 192.906 887.635 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M886.338 192.907C886.433 192.909 886.509 192.99 886.507 193.088L886.217 210.258C886.215 210.356 886.137 210.434 886.042 210.433C885.947 210.431 885.871 210.35 885.873 210.252L886.163 193.082C886.165 192.984 886.243 192.906 886.338 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M887.876 192.909C887.971 192.907 888.05 192.985 888.051 193.083L888.342 210.253C888.343 210.352 888.268 210.432 888.173 210.434C888.078 210.436 887.999 210.358 887.998 210.26L887.708 193.089C887.706 192.991 887.782 192.91 887.876 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M889.265 210.946H884.83V211.946H889.265V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M889.265 190.484H884.83V191.484H889.265V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M888.545 191.574H885.549C885.35 191.574 885.189 191.735 885.189 191.934V192.214C885.189 192.413 885.35 192.574 885.549 192.574H888.545C888.744 192.574 888.905 192.413 888.905 192.214V191.934C888.905 191.735 888.744 191.574 888.545 191.574Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M897.177 211.914L896.753 192.428H893.864L893.267 211.914L893.864 212.698H896.753L897.177 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M895.787 192.906H895.387C895.221 192.906 895.087 193.04 895.087 193.206V210.162C895.087 210.327 895.221 210.462 895.387 210.462H895.787C895.952 210.462 896.087 210.327 896.087 210.162V193.206C896.087 193.04 895.952 192.906 895.787 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M894.489 192.907C894.584 192.909 894.66 192.99 894.658 193.088L894.368 210.258C894.367 210.356 894.288 210.434 894.193 210.433C894.098 210.431 894.023 210.35 894.024 210.252L894.315 193.082C894.316 192.984 894.395 192.906 894.489 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M896.028 192.909C896.123 192.907 896.201 192.985 896.203 193.083L896.493 210.253C896.495 210.352 896.419 210.432 896.324 210.434C896.229 210.436 896.151 210.358 896.149 210.26L895.859 193.089C895.857 192.991 895.933 192.91 896.028 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M897.416 210.946H892.981V211.946H897.416V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M897.416 190.484H892.981V191.484H897.416V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M896.697 191.574H893.701C893.502 191.574 893.341 191.735 893.341 191.934V192.214C893.341 192.413 893.502 192.574 893.701 192.574H896.697C896.896 192.574 897.057 192.413 897.057 192.214V191.934C897.057 191.735 896.896 191.574 896.697 191.574Z",
  fill: "#4D00B4"
})), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M905.328 211.914L904.905 192.428H902.016L901.418 211.914L902.016 212.698H904.905L905.328 211.914Z",
  fill: "#4D00B4"
}), React.createElement("g", {
  opacity: 0.802781
}, React.createElement("path", {
  opacity: 0.802781,
  d: "M903.938 192.906H903.538C903.372 192.906 903.238 193.04 903.238 193.206V210.162C903.238 210.327 903.372 210.462 903.538 210.462H903.938C904.104 210.462 904.238 210.327 904.238 210.162V193.206C904.238 193.04 904.104 192.906 903.938 192.906Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M902.641 192.907C902.736 192.909 902.812 192.99 902.81 193.088L902.52 210.258C902.518 210.356 902.44 210.434 902.345 210.433C902.25 210.431 902.174 210.35 902.176 210.252L902.466 193.082C902.468 192.984 902.546 192.906 902.641 192.907Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M904.179 192.909C904.274 192.907 904.353 192.985 904.354 193.083L904.644 210.253C904.646 210.352 904.57 210.432 904.476 210.434C904.381 210.436 904.302 210.358 904.301 210.26L904.01 193.089C904.009 192.991 904.084 192.91 904.179 192.909Z",
  fill: "#9013FE"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M905.568 210.946H901.133V211.946H905.568V210.946Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M905.568 190.484H901.133V191.484H905.568V190.484Z",
  fill: "#9013FE"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M904.848 191.574H901.852C901.653 191.574 901.492 191.735 901.492 191.934V192.214C901.492 192.413 901.653 192.574 901.852 192.574H904.848C905.047 192.574 905.208 192.413 905.208 192.214V191.934C905.208 191.735 905.047 191.574 904.848 191.574Z",
  fill: "#4D00B4"
})), React.createElement("path", {
  opacity: 0.802781,
  d: "M845.271 185.52H844.192V188.305H845.271V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M905.568 185.52H904.489V188.305H905.568V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M846.751 185.52H845.751V188.305H846.751V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M849.467 185.52H846.71V188.305H849.467V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M850.946 185.52H849.946V188.305H850.946V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M853.662 185.52H850.905V188.305H853.662V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M855.142 185.52H854.142V188.305H855.142V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M857.858 185.52H855.101V188.305H857.858V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M859.338 185.52H858.338V188.305H859.338V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M862.054 185.52H859.297V188.305H862.054V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M863.533 185.52H862.533V188.305H863.533V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M866.249 185.52H863.492V188.305H866.249V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M867.729 185.52H866.729V188.305H867.729V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M870.445 185.52H867.688V188.305H870.445V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M871.924 185.52H870.924V188.305H871.924V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M874.64 185.52H871.883V188.305H874.64V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M876.12 185.52H875.12V188.305H876.12V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M878.836 185.52H876.079V188.305H878.836V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M880.315 185.52H879.315V188.305H880.315V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M883.032 185.52H880.274V188.305H883.032V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M884.511 185.52H883.511V188.305H884.511V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M887.227 185.52H884.47V188.305H887.227V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M888.707 185.52H887.707V188.305H888.707V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M891.423 185.52H888.666V188.305H891.423V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M892.902 185.52H891.902V188.305H892.902V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M895.618 185.52H892.861V188.305H895.618V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M897.098 185.52H896.098V188.305H897.098V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M899.814 185.52H897.057V188.305H899.814V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M901.293 185.52H900.293V188.305H901.293V185.52Z",
  fill: "#4D00B4"
}), React.createElement("path", {
  opacity: 0.802781,
  d: "M904.009 185.52H901.252V188.305H904.009V185.52Z",
  fill: "#4D00B4"
})));

var _ref139 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M426.53 385.677L577.555 369.734L980.792 376.808L1036.7 387L1052.56 376.808L1466.33 382.969L1487.37 369.734L1592.48 382.969L1634.63 376.808C1669.31 385.56 1694.78 390.747 1711.05 392.367C1717.87 393.046 1723.35 393.127 1727.49 392.609C1732.13 392.029 1736.35 395.316 1736.93 399.951C1736.98 400.299 1737 400.649 1737 401C1737 408.732 1730.73 415 1723 415H428C420.268 415 414 408.732 414 401V399.6C414 392.437 419.407 386.429 426.53 385.677Z",
  fill: "#EAD6FE"
});

var _ref140 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1210.85 398.388C1208.1 399.43 1205.12 400 1202 400C1188.19 400 1177 388.807 1177 375C1177 361.193 1188.19 350 1202 350C1204.51 350 1206.93 350.37 1209.22 351.058C1213.74 339.883 1224.7 332 1237.5 332C1254.01 332 1267.46 345.124 1267.98 361.511C1270.91 359.306 1274.55 358 1278.5 358C1288.16 358 1296 365.835 1296 375.5C1296 376.705 1295.88 377.882 1295.65 379.019C1298.31 381.311 1300 384.708 1300 388.5C1300 395.404 1294.4 401 1287.5 401H1218.5C1215.62 401 1212.97 400.025 1210.85 398.388Z",
  fill: "#9013FE"
});

var _ref141 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1203 395C1214.05 395 1223 386.046 1223 375C1223 363.954 1214.05 355 1203 355C1191.95 355 1183 363.954 1183 375C1183 386.046 1191.95 395 1203 395Z",
  fill: "url(#paint1_linear)"
});

var _ref142 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1238.5 395C1254.24 395 1267 382.24 1267 366.5C1267 350.76 1254.24 338 1238.5 338C1222.76 338 1210 350.76 1210 366.5C1210 382.24 1222.76 395 1238.5 395Z",
  fill: "url(#paint2_linear)"
});

var _ref143 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1281 386C1287.63 386 1293 380.627 1293 374C1293 367.373 1287.63 362 1281 362C1274.37 362 1269 367.373 1269 374C1269 380.627 1274.37 386 1281 386Z",
  fill: "url(#paint3_linear)"
});

var _ref144 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1287.5 397C1292.19 397 1296 393.194 1296 388.5C1296 383.806 1292.19 380 1287.5 380C1282.81 380 1279 383.806 1279 388.5C1279 393.194 1282.81 397 1287.5 397Z",
  fill: "url(#paint4_linear)"
});

var _ref145 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M811.136 392.213C812.999 392.927 815.019 393.319 817.13 393.319C826.447 393.319 834 385.695 834 376.29C834 366.885 826.447 359.261 817.13 359.261C815.436 359.261 813.801 359.513 812.259 359.982C809.205 352.369 801.811 347 793.175 347C782.031 347 772.957 355.939 772.604 367.101C770.629 365.6 768.171 364.71 765.508 364.71C758.986 364.71 753.699 370.047 753.699 376.63C753.699 377.459 753.783 378.267 753.942 379.048C752.14 380.609 751 382.914 751 385.486C751 390.188 754.812 394 759.514 394H805.916C807.883 394 809.695 393.333 811.136 392.213Z",
  fill: "#9013FE"
});

var _ref146 =
/*#__PURE__*/
React.createElement("path", {
  d: "M816.5 390C809.044 390 803 383.956 803 376.5C803 369.044 809.044 363 816.5 363C823.956 363 830 369.044 830 376.5C830 383.956 823.956 390 816.5 390Z",
  fill: "url(#paint5_linear)"
});

var _ref147 =
/*#__PURE__*/
React.createElement("path", {
  d: "M793 390C782.507 390 774 381.27 774 370.5C774 359.73 782.507 351 793 351C803.493 351 812 359.73 812 370.5C812 381.27 803.493 390 793 390Z",
  fill: "url(#paint6_linear)"
});

var _ref148 =
/*#__PURE__*/
React.createElement("path", {
  d: "M764 384C759.582 384 756 380.418 756 376C756 371.582 759.582 368 764 368C768.418 368 772 371.582 772 376C772 380.418 768.418 384 764 384Z",
  fill: "url(#paint7_linear)"
});

var _ref149 =
/*#__PURE__*/
React.createElement("path", {
  d: "M759.5 391C756.462 391 754 388.314 754 385C754 381.686 756.462 379 759.5 379C762.538 379 765 381.686 765 385C765 388.314 762.538 391 759.5 391Z",
  fill: "url(#paint8_linear)"
});

var _ref150 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1387.26 216.422C1387.94 216.84 1388.71 217.138 1389.54 217.285C1393.19 217.928 1396.68 215.414 1397.34 211.67C1398 207.926 1395.58 204.369 1391.93 203.726C1391.27 203.609 1390.61 203.596 1389.97 203.676C1389.31 200.435 1386.8 197.787 1383.41 197.191C1379.05 196.421 1374.87 199.354 1373.95 203.773C1373.28 203.039 1372.38 202.515 1371.34 202.331C1368.78 201.881 1366.34 203.641 1365.88 206.262C1365.82 206.596 1365.79 206.929 1365.8 207.255C1364.99 207.752 1364.38 208.585 1364.2 209.6C1363.87 211.473 1365.12 213.258 1366.99 213.588L1385.05 216.772C1385.83 216.911 1386.61 216.77 1387.26 216.422Z",
  fill: "#9013FE"
});

var _ref151 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1389.53 215.92C1386.61 215.405 1384.67 212.582 1385.19 209.613C1385.71 206.645 1388.5 204.656 1391.42 205.171C1394.34 205.686 1396.29 208.509 1395.76 211.478C1395.24 214.446 1392.45 216.435 1389.53 215.92Z",
  fill: "url(#paint9_linear)"
});

var _ref152 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1380.33 214.298C1376.22 213.573 1373.5 209.51 1374.26 205.223C1375.01 200.935 1378.96 198.047 1383.06 198.771C1387.17 199.496 1389.89 203.559 1389.14 207.846C1388.38 212.134 1384.44 215.022 1380.33 214.298Z",
  fill: "url(#paint10_linear)"
});

var _ref153 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1369.39 209.907C1367.66 209.602 1366.51 207.929 1366.82 206.17C1367.13 204.411 1368.79 203.232 1370.52 203.537C1372.25 203.842 1373.4 205.515 1373.09 207.274C1372.78 209.033 1371.12 210.212 1369.39 209.907Z",
  fill: "url(#paint11_linear)"
});

var _ref154 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1367.14 212.383C1365.95 212.173 1365.17 210.933 1365.41 209.614C1365.64 208.295 1366.79 207.395 1367.98 207.605C1369.17 207.815 1369.95 209.054 1369.71 210.374C1369.48 211.693 1368.33 212.592 1367.14 212.383Z",
  fill: "url(#paint12_linear)"
});

var _ref155 =
/*#__PURE__*/
React.createElement("path", {
  d: "M874.5 380C878.642 380 882 354.48 882 323C882 291.52 878.642 266 874.5 266C870.358 266 867 291.52 867 323C867 354.48 870.358 380 874.5 380Z",
  fill: "#9013FE"
});

var _ref156 =
/*#__PURE__*/
React.createElement("path", {
  d: "M900.5 380C902.985 380 905 364.33 905 345C905 325.67 902.985 310 900.5 310C898.015 310 896 325.67 896 345C896 364.33 898.015 380 900.5 380Z",
  fill: "#9013FE"
});

var _ref157 =
/*#__PURE__*/
React.createElement("path", {
  d: "M876 379H873V390H876V379Z",
  fill: "#4D00B4"
});

var _ref158 =
/*#__PURE__*/
React.createElement("path", {
  d: "M901 379H900V390H901V379Z",
  fill: "#4D00B4"
});

var _ref159 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1394.5 384C1390.36 384 1387 358.48 1387 327C1387 295.52 1390.36 270 1394.5 270C1398.64 270 1402 295.52 1402 327C1402 358.48 1398.64 384 1394.5 384Z",
  fill: "#9013FE"
});

var _ref160 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1368.5 384C1366.01 384 1364 368.33 1364 349C1364 329.67 1366.01 314 1368.5 314C1370.99 314 1373 329.67 1373 349C1373 368.33 1370.99 384 1368.5 384Z",
  fill: "#9013FE"
});

var _ref161 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1393 383H1396V394H1393V383Z",
  fill: "#4D00B4"
});

var _ref162 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1368 383H1369V394H1368V383Z",
  fill: "#4D00B4"
});

var _ref163 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1153.72 379C1156.88 379 1159.45 359.301 1159.45 335C1159.45 310.699 1156.88 291 1153.72 291C1150.56 291 1148 310.699 1148 335C1148 359.301 1150.56 379 1153.72 379Z",
  fill: "#9013FE"
});

var _ref164 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1173.57 379C1175.46 379 1177 366.904 1177 351.982C1177 337.061 1175.46 324.965 1173.57 324.965C1171.67 324.965 1170.13 337.061 1170.13 351.982C1170.13 366.904 1171.67 379 1173.57 379Z",
  fill: "#9013FE"
});

var _ref165 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1155 378H1153V387H1155V378Z",
  fill: "#4D00B4"
});

var _ref166 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1174 378H1173V387H1174V378Z",
  fill: "#4D00B4"
});

var _ref167 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M947.489 219.945L946.43 171.802H939.208L937.714 219.945L939.208 221.882H946.43L947.489 219.945Z",
  fill: "#4D00B4"
});

var _ref168 =
/*#__PURE__*/
React.createElement("path", {
  d: "M943.264 173.482C943.264 173.206 943.04 172.982 942.764 172.982C942.488 172.982 942.264 173.206 942.264 173.482V215.856C942.264 216.132 942.488 216.356 942.764 216.356C943.04 216.356 943.264 216.132 943.264 215.856V173.482Z",
  fill: "#9013FE"
});

var _ref169 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M940.771 172.986C941.008 172.99 941.198 173.19 941.193 173.432L940.468 215.853C940.464 216.095 940.268 216.288 940.031 216.284C939.793 216.28 939.604 216.08 939.608 215.838L940.334 173.417C940.338 173.175 940.534 172.982 940.771 172.986Z",
  fill: "#9013FE"
});

var _ref170 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M944.617 172.99C944.854 172.986 945.05 173.179 945.054 173.421L945.78 215.842C945.784 216.084 945.595 216.284 945.357 216.288C945.12 216.293 944.924 216.1 944.92 215.857L944.195 173.437C944.191 173.194 944.38 172.995 944.617 172.99Z",
  fill: "#9013FE"
});

var _ref171 =
/*#__PURE__*/
React.createElement("path", {
  d: "M948.088 217.552H937V219.945H948.088V217.552Z",
  fill: "#9013FE"
});

var _ref172 =
/*#__PURE__*/
React.createElement("path", {
  d: "M948.088 167H937V169.393H948.088V167Z",
  fill: "#9013FE"
});

var _ref173 =
/*#__PURE__*/
React.createElement("path", {
  d: "M946.292 169.692H938.796C938.301 169.692 937.899 170.094 937.899 170.59C937.899 171.085 938.301 171.487 938.796 171.487H946.292C946.787 171.487 947.189 171.085 947.189 170.59C947.189 170.094 946.787 169.692 946.292 169.692Z",
  fill: "#4D00B4"
});

var _ref174 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M816.784 216.163L816.402 196.919H813.796L813.258 216.163L813.796 216.937H816.402L816.784 216.163Z",
  fill: "#4D00B4"
});

var _ref175 =
/*#__PURE__*/
React.createElement("path", {
  d: "M815.599 197.391H815.199C815.033 197.391 814.899 197.525 814.899 197.691V214.428C814.899 214.594 815.033 214.728 815.199 214.728H815.599C815.765 214.728 815.899 214.594 815.899 214.428V197.691C815.899 197.525 815.765 197.391 815.599 197.391Z",
  fill: "#9013FE"
});

var _ref176 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M814.36 197.393C814.446 197.394 814.514 197.474 814.513 197.571L814.251 214.527C814.25 214.624 814.179 214.701 814.093 214.699C814.008 214.698 813.939 214.618 813.941 214.521L814.203 197.565C814.204 197.468 814.275 197.391 814.36 197.393Z",
  fill: "#9013FE"
});

var _ref177 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M815.748 197.394C815.833 197.392 815.904 197.47 815.906 197.566L816.167 214.522C816.169 214.619 816.1 214.699 816.015 214.701C815.929 214.703 815.859 214.625 815.857 214.529L815.595 197.573C815.594 197.476 815.662 197.396 815.748 197.394Z",
  fill: "#9013FE"
});

var _ref178 =
/*#__PURE__*/
React.createElement("path", {
  d: "M817 215.207H813V216.207H817V215.207Z",
  fill: "#9013FE"
});

var _ref179 =
/*#__PURE__*/
React.createElement("path", {
  d: "M817 195H813V196H817V195Z",
  fill: "#9013FE"
});

var _ref180 =
/*#__PURE__*/
React.createElement("path", {
  d: "M816.316 196.076H813.684C813.485 196.076 813.324 196.237 813.324 196.436V196.716C813.324 196.915 813.485 197.076 813.684 197.076H816.316C816.514 197.076 816.676 196.915 816.676 196.716V196.436C816.676 196.237 816.514 196.076 816.316 196.076Z",
  fill: "#4D00B4"
});

var _ref181 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M931 216.881H809L800.26 226.381L931 216.881Z",
  fill: "#4D00B4"
});

var _ref182 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.234166,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1163 350L1171.37 210.433V338L1163 350Z",
  fill: "#9013FE"
});

var _ref183 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M385 393H428V415H364.064L385 393Z",
  fill: "#EAD6FE"
});

var _ref184 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1756 397H1713V415H1776.94L1756 397Z",
  fill: "#EAD6FE"
});

var _ref185 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M839.976 113.76C845.661 112.075 854.311 111 864 111C881.121 111 895 114.358 895 118.5C895 122.642 881.121 126 864 126C861.196 126 858.479 125.91 855.896 125.741C855.965 125.99 856 126.243 856 126.5C856 130.09 849.06 133 840.5 133C835.219 133 830.555 131.892 827.756 130.201C816.286 136.751 797.823 141 777 141C757.973 141 740.916 137.452 729.365 131.843C724.59 132.583 719.202 133 713.5 133C693.894 133 678 128.075 678 122C678 115.925 693.894 111 713.5 111C713.849 111 714.197 111.002 714.543 111.005C718.61 98.0211 745.023 88 777 88C811.205 88 839.044 99.4664 839.976 113.76Z",
  fill: "white"
});

var _ref186 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1690.02 87.7597C1684.34 86.0754 1675.69 85 1666 85C1648.88 85 1635 88.3579 1635 92.5C1635 96.6421 1648.88 100 1666 100C1668.8 100 1671.52 99.9099 1674.1 99.7411C1674.04 99.99 1674 100.243 1674 100.5C1674 104.09 1680.94 107 1689.5 107C1694.78 107 1699.45 105.892 1702.24 104.201C1713.71 110.751 1732.18 115 1753 115C1772.03 115 1789.08 111.452 1800.64 105.843C1805.41 106.583 1810.8 107 1816.5 107C1836.11 107 1852 102.075 1852 96C1852 89.9249 1836.11 85 1816.5 85C1816.15 85 1815.8 85.0016 1815.46 85.0047C1811.39 72.0211 1784.98 62 1753 62C1718.79 62 1690.96 73.4664 1690.02 87.7597Z",
  fill: "white"
});

var _ref187 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M513.002 194.355C510.07 193.524 505.78 193 501 193C492.163 193 485 194.791 485 197C485 199.209 492.163 201 501 201C502.397 201 503.753 200.955 505.044 200.871C505.468 202.63 508.868 204 513 204C515.646 204 517.991 203.438 519.448 202.572C525.374 205.867 534.837 208 545.5 208C555.261 208 564.017 206.212 569.975 203.382C572.526 203.777 575.425 204 578.5 204C588.717 204 597 201.538 597 198.5C597 195.462 588.717 193 578.5 193C578.267 193 578.034 193.001 577.803 193.004C576.011 186.252 562.232 181 545.5 181C527.667 181 513.189 186.966 513.002 194.355Z",
  fill: "white"
});

var _ref188 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M322.006 96.7162C320.202 96.2732 317.729 96 315 96C309.477 96 305 97.1193 305 98.5C305 99.8807 309.477 101 315 101C315.883 101 316.74 100.971 317.556 100.918C318.388 101.561 320.065 102 322 102C323.425 102 324.71 101.762 325.621 101.379C329.239 103.569 335.226 105 342 105C347.599 105 352.66 104.022 356.291 102.447C358.082 102.797 360.213 103 362.5 103C368.851 103 374 101.433 374 99.5C374 97.567 368.851 96 362.5 96C362.321 96 362.143 96.0012 361.966 96.0037C361.362 91.5403 352.654 88 342 88C330.954 88 322 91.8056 322 96.5C322 96.5723 322.002 96.6443 322.006 96.7162Z",
  fill: "white"
});

var _ref189 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1952.01 172.716C1950.2 172.273 1947.73 172 1945 172C1939.48 172 1935 173.119 1935 174.5C1935 175.881 1939.48 177 1945 177C1945.88 177 1946.74 176.971 1947.56 176.918C1948.39 177.561 1950.07 178 1952 178C1953.42 178 1954.71 177.762 1955.62 177.379C1959.24 179.569 1965.23 181 1972 181C1977.6 181 1982.66 180.022 1986.29 178.447C1988.08 178.797 1990.21 179 1992.5 179C1998.85 179 2004 177.433 2004 175.5C2004 173.567 1998.85 172 1992.5 172C1992.32 172 1992.14 172.001 1991.97 172.004C1991.36 167.54 1982.65 164 1972 164C1960.95 164 1952 167.806 1952 172.5C1952 172.572 1952 172.644 1952.01 172.716Z",
  fill: "white"
});

var _ref190 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 1271.4,
  y1: 68.5127,
  x2: 1266.58,
  y2: 415.777,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9013FE"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 1194.58,
  y1: 375,
  x2: 1212.23,
  y2: 375,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 1226.51,
  y1: 366.5,
  x2: 1251.65,
  y2: 366.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 1275.95,
  y1: 374,
  x2: 1286.54,
  y2: 374,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 1283.92,
  y1: 388.5,
  x2: 1291.42,
  y2: 388.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 822.181,
  y1: 376.5,
  x2: 810.271,
  y2: 376.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 800.995,
  y1: 370.5,
  x2: 784.233,
  y2: 370.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 767.366,
  y1: 376,
  x2: 760.309,
  y2: 376,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 761.814,
  y1: 385,
  x2: 756.962,
  y2: 385,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 1392.7,
  y1: 210.938,
  x2: 1388.04,
  y2: 210.115,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 1384.83,
  y1: 207.086,
  x2: 1378.26,
  y2: 205.929,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 1371.27,
  y1: 206.954,
  x2: 1368.51,
  y2: 206.467,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})), React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 1368.47,
  y1: 210.154,
  x2: 1366.57,
  y2: 209.819,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.192227
})));

var SvgAcropolis = function SvgAcropolis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 2238,
    height: 415,
    viewBox: "0 0 2238 415",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAcropolis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/acropolis.e073eb10.svg";
export { ForwardRef as ReactComponent };